import React, { useState, useEffect, useRef } from "react";
import downloadFile from "../../../utils/downloadFile";

import IconPlusWhite from "../../../assets/icons/iconAddHeader.svg";
import BlackLoupe from "../../../assets/icons/icon-search-gray.png";
import IconBell from "../../../assets/icons/icons-bell-productors.svg";
import ArrowDown from "../../../assets/icons/icon-arrow-down-circle-gray.png";
import IconHelp from "../../../assets/icons/help";

import ItemNotFound from "../../../assets/img-undraw-search.svg";
import IconSearchNotFound from "../../../assets/icons/icons8-search-notfound.png";
import IconPenEdit from "../../../assets/icons/icon-pen-edit.png";
import IconBarChartGray from '../../../assets/icons/icon-bar-chart-gray.png';
import IconClose from "../../../assets/icons/close.svg";

import identifyErrorMenssage from "../../../services/identifyErrorMenssage";
import Badge from "../../badge";
import TextOrStatus from "../../textOrStatus";

import * as S from "./styles";
import {
  Auxiliar,
  BodyG,
  BodyM,
  H6,
  H5,
  TaglineM,
  TaglineP,
} from "../../../styles/stylesTypography";
import { theme } from "../../../styles/theme";
import api from "../../../services/api";
import { isTotvs, isOmie } from "../../../services/globalFunctions";
import ButtonList from "../../button-list";
import SimpleTable from "../../../components/tbody/simple-index.js";
import Modal from "../../modal/modalGeneric";
import { store } from "react-notifications-component";
import { SimpleTBodyContainer } from "../../../components/tbody/styles.js";
import PlanilhaDropzone, { formatFileSize } from "../../planilha-dropzone";
import ButtonV2 from "../../button/button_v2";
import ModalGeneric from "../../modal/modalGeneric";
import TabTitle from "../../tabTitle";
import { Container as ModalContainer } from "../../modal/styles";
import ModalImageRecursoClientes from "../../../assets/modalRecursoClientes.svg";
import PaginatorV2 from "../../paginator/indexV2";

import Search from "../../search/index.js";
import TableWithLabelBlackV2 from "../../TableWithLabelBlack/indexV2.js";
import SwitchLayout from "../../SwitchLayout/index.js";
import { openCulturaUrl } from "../../../utils/culturasPdf";

const USER = "@userinfo";

const getPlanId = (user) =>
  user?.contrato?.agro_plan_config?.agro_plan_id ??
  user?.contrato?.agro_plan_id ??
  user?.agro_plan_id ??
  user?.agro_plan_config?.agro_plan_id;

const getDiasRestante = (user) =>
  Number(user?.contrato?.dias_restante ?? user?.dias_restante ?? 0);

// "Teste gratis acabou" exige as DUAS coisas: ser um plano de teste E o prazo
// ter passado. So o prazo nao serve porque `dias_restante` nao e um contador de
// teste - a API devolve `data_vencimento - hoje` para QUALQUER plano
// (auth.service.ts), entao um cliente pagante com contrato vencido ficava
// negativo e levava o modal "Recurso exclusivo para clientes". Atraso de
// pagamento nao bloqueia funcionalidade: quem cobra isso e a cobranca, nao a
// tela. (O `isFunctionBlocked` abaixo sempre cruzou plano com prazo; aqui a
// checagem de plano tinha ficado de fora.)
const isTrialPlan = (user) =>
  Number(user?.contrato?.agro_plan_config?.is_teste) === 1 || getPlanId(user) === 1;

const isExpiredTrial = (user) => isTrialPlan(user) && getDiasRestante(user) < 0;

// Basic/Light/Prepaid or Free expired
const isFunctionBlocked = (user) => {
  const planId = getPlanId(user);
  const diasRestante = getDiasRestante(user);

  return (
    planId === 7 ||
    planId === 6 ||
    planId === 4 ||
    (planId === 1 && diasRestante <= 0)
  );
};

const getUserFromStorage = () => {
  try {
    return JSON.parse(localStorage.getItem("@userinfo"));
  } catch {
    return null;
  }
};

// Ícones das abas "Produtores" / "Locais de aplicação" dos modais de importação — reaproveitados
// pelos dois modais (Importar dados / Importar com IA) via o componente TabTitle.
const IconProdutoresTab = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <circle cx="8" cy="5" r="2.5" stroke="currentColor" strokeWidth="1.5" />
    <path d="M3 13.5c.7-2.3 2.7-3.5 5-3.5s4.3 1.2 5 3.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);
const IconLocaisAplicacaoTab = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M2 13V6l6-4 6 4v7" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
    <path d="M6 13v-4h4v4" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
  </svg>
);

const ListaProdutores = ({ ...props }) => {
  const DEFAULT_LIMIT = 30;
  const EXPANDED_LIMIT = 12;

  const [showAll, setShowAll] = useState(false);
  const [loading, setLoading] = useState(false)
  const [limit, setLimit] = useState(DEFAULT_LIMIT);
  const [offset, setOffset] = useState(0);
  const [produtores, setProdutores] = useState([]);
  const [totalProdutores, setTotalProdutores] = useState(0);
  const [showRelatorios, setShowRelatorios] = useState(false);
  const [search, setSearch] = useState("")
  const [order, setOrder] = useState({
    value: "modified",
    label: "Últimas atualizações",
    order: "DESC",
  });
  const [layoutView, setLayoutView] = useState(window.innerWidth < 760 ? "cards" : "table");
  const [layoutLoading, setLayoutLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageLoading, setPageLoading] = useState(false);

  // Modal e Tooltip
  const [loadingImport, setLoadingImport] = useState(false);
  const [file, setFile] = useState([]);
  const [showUpdate, setShowUpdate] = useState(true);
  const [tipoImport, setTipoImport] = useState(1);
  const [namesfiles, setNamesfiles] = useState([]);
  const [textfile, setTextfile] = useState("");
  const [showModalProducer, setShowModalProducer] = useState(false);
  const [showModalImportPlanilha, setShowModalImportPlanilha] = useState(false);
  const [showModalImportIA, setShowModalImportIA] = useState(false);

  // Validação
  const [loadingValidate, setLoadingValidate] = useState(false);
  const [openValidate, setOpenValidate] = useState(false);
  const [errosArquivo, setErrosArquivo] = useState([]);

  const [openModalBlocked, setOpenModalBlocked] = useState(false);
  const [openModalTesteGratis, setOpenModalTesteGratis] = useState(false);

  const containerRef = useRef(null);
  const tooltipRef = useRef(null);
  const buttonRef = useRef(null);

  const orderRef = useRef(order);
  const searchDebounceTimeoutRef = useRef(null);
  const didMountSearchRef = useRef(false);

  const userData = JSON.parse(localStorage.getItem(USER) || "null");
  const userEmail = userData?.username || userData?.email || "";
  const isTotvsUser = isTotvs();
  const isMaster = userData?.agro_permission_id === 4;
  // Plano Omie: qualquer usuário pode adicionar produtor manual (backend já cria o
  // cliente na Omie junto, ver produtores.service.ts) - só Totvs/Protheus (9/10)
  // continuam restritos a master.
  const canAddProdutor = isOmie() ? true : !(isTotvsUser && !isMaster);

  const [loadingRelatorio, setLoadingRelatorio] = useState(false);

  const USER_EMAIL = JSON.parse(localStorage.getItem("@userinfo"));

  const fetchProdutores = async ({
    nextOrder = order,
    nextLimit = limit,
    nextOffset = offset,
  } = {}) => {
    try {
      setLoading(true);
      const response = await api.post(`/produtores/pesquisa?limit=${nextLimit}&offset=${nextOffset}`, {
        search,
        estado: "",
        order_by: {
          field: nextOrder.value,
          order: nextOrder.order,
        },
      },
      );

      setProdutores(response.data.data.produtores);
      setTotalProdutores(response.data.data.total);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const updateLimitOffset = async (
    l,
    o,
    nextOrder = order,
    { showPageLoading = false } = {},
  ) => {
    setLimit(l);
    setOffset(o);
    setCurrentPage(l > 0 ? Math.floor(o / l) + 1 : 1);
    if (showPageLoading) {
      setPageLoading(true);
    }

    try {
      await fetchProdutores({ nextLimit: l, nextOffset: o, nextOrder });
    } finally {
      if (showPageLoading) {
        setPageLoading(false);
      }
    }
  };

  const toggleShowAll = () => {
    const nextShowAll = !showAll;
    const nextLimit = nextShowAll ? EXPANDED_LIMIT : DEFAULT_LIMIT;
    const maxOffset = Math.max(
      0,
      (Math.max(Math.ceil(totalProdutores / nextLimit), 1) - 1) * nextLimit,
    );
    const nextOffset = Math.min(offset, maxOffset);

    setShowAll(nextShowAll);
    updateLimitOffset(nextLimit, nextOffset, order, {
      showPageLoading: layoutView === "table",
    });
  };

  const changeLayoutView = (next) => {
    if (next === layoutView) return;
    if (layoutLoading) return;
    setLayoutLoading(true);
    setTimeout(() => {
      setLayoutView(next);
      setLayoutLoading(false);
    }, 350);
  };

  const getProdutoresReset = async (order) => {
    try {
      setShowAll(false);
      setOffset(0);
      setLimit(DEFAULT_LIMIT);
      setCurrentPage(1);
      await fetchProdutores({
        nextLimit: DEFAULT_LIMIT,
        nextOffset: 0,
        nextOrder: order,
      });
    } catch (error) {
      setLoading(false);
    }
  };

  function formatarData(dataISO) {
    const data = new Date(dataISO);

    const opcoesData = { day: "2-digit", month: "short", year: "numeric" };
    const dataFormatada = data.toLocaleDateString("pt-BR", opcoesData);

    const opcoesHora = { hour: "2-digit", minute: "2-digit", hour12: false };
    const horaFormatada = data.toLocaleTimeString("pt-BR", opcoesHora);

    const dataFinal =
      dataFormatada.replace(".", "").split(" de ").join("/") +
      ", " +
      horaFormatada;

    return dataFinal;
  }

  const onKeyDown = (e) => {
    if (e.key === "Enter") {
      if (searchDebounceTimeoutRef.current) {
        clearTimeout(searchDebounceTimeoutRef.current);
        searchDebounceTimeoutRef.current = null;
      }
      getProdutoresReset(order);
    }
  };

  const updateOrder = (e) => {
    setOrder(e);
    getProdutoresReset(e);
  };

  const deleteFile = () => {
    setFile([]);
    setNamesfiles([]);
    setTextfile("");
  };

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.style.height = showAll
        ? `${containerRef.current.scrollHeight}px`
        : "100%";
    }
  }, [showAll]);

  useEffect(() => {
    fetchProdutores({
      nextLimit: DEFAULT_LIMIT,
      nextOffset: 0,
      nextOrder: order,
    });
  }, []);

  useEffect(() => {
    setShowUpdate(false);
  }, [tipoImport]);

  useEffect(() => {
    if (showUpdate === false) {
      setTimeout(() => {
        setShowUpdate(true);
      }, 50);
    }
  }, [showUpdate]);

  useEffect(() => {
    orderRef.current = order;
  }, [order]);

  useEffect(() => {
    if (openValidate && !loadingValidate && errosArquivo.length === 0) {
      setOpenValidate(false);
    }
  }, [openValidate, loadingValidate, errosArquivo]);

  useEffect(() => {
    if (!didMountSearchRef.current) {
      didMountSearchRef.current = true;
      return;
    }

    if (searchDebounceTimeoutRef.current) {
      clearTimeout(searchDebounceTimeoutRef.current);
    }

    searchDebounceTimeoutRef.current = setTimeout(() => {
      getProdutoresReset(orderRef.current);
    }, 2000);

    return () => {
      if (searchDebounceTimeoutRef.current) {
        clearTimeout(searchDebounceTimeoutRef.current);
        searchDebounceTimeoutRef.current = null;
      }
    };
  }, [search]);

  const rediretcToProducer = (id) => {
    window.location = `/produtores/${id}`;
  };

  const redirectToProducerAdd = () => {
    window.location = `/produtores/add`;
  };

  const closeValidate = () => {
    setFile([]);
    setNamesfiles([]);
    setTextfile("");
    setOpenValidate(false);
    setErrosArquivo([]);
  };

  const downloadProducersModel = () => {
    window.open(
      "https://sudeste-online.s3.amazonaws.com/importacoes/importarprodutores.xlsx",
      "_blank",
    );
  };

  const downloadFarmsModel = () => {
    window.open(
      "https://sudeste-online.s3.us-east-1.amazonaws.com/importacoes/Importarlocaisdeaplicacao.xlsx",
      "_blank",
    );
  };

  const goToImportTutorial = () => {
    window.open(
      "https://agroreceita.com.br/como-importar-produtores-e-locais-de-aplicacao/",
      "_blank",
    );
  };

  const getXlms = async () => {
    const user = getUserFromStorage();

    if (isExpiredTrial(user)) {
      setShowRelatorios(false);
      setOpenModalTesteGratis(true);
      return;
    }

    if (isFunctionBlocked(user)) {
      setShowRelatorios(false);
      setOpenModalBlocked(true);
      return;
    }

    setShowRelatorios(false);
    setLoadingRelatorio(true);
    window.onbeforeunload = () => 'Seu relatório está sendo gerado. Tem certeza que deseja sair?';

    try {
      const response = await api.get("/produtores/relatorio");

      if (response.data.downloadUrl) {
        await downloadFile(response.data.downloadUrl, 'relatorio-produtores.xlsx');
      }

      store.addNotification({
        title: "Sucesso!",
        message: "Relatório gerado com sucesso.",
        type: "success",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 6000, onScreen: true },
      });
    } catch (error) {
      store.addNotification({
        title: "Erro!",
        message: identifyErrorMenssage(error),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 5000, onScreen: true },
      });
    } finally {
      setLoadingRelatorio(false);
      window.onbeforeunload = null;
    }
  };

  const getXlmsFarms = async () => {
    const user = getUserFromStorage();

    if (isExpiredTrial(user)) {
      setShowRelatorios(false);
      setOpenModalTesteGratis(true);
      return;
    }

    if (isFunctionBlocked(user)) {
      setShowRelatorios(false);
      setOpenModalBlocked(true);
      return;
    }

    setShowRelatorios(false);
    setLoadingRelatorio(true);
    window.onbeforeunload = () => 'Seu relatório está sendo gerado. Tem certeza que deseja sair?';

    try {
      const response = await api.get("/relatorios/fazendas");

      if (response.data.downloadUrl) {
        await downloadFile(response.data.downloadUrl, 'relatorio-produtores.xlsx');
      }

      store.addNotification({
        title: "Sucesso!",
        message: "Relatório gerado com sucesso.",
        type: "success",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 6000, onScreen: true },
      });
    } catch (error) {
      store.addNotification({
        title: "Erro!",
        message: identifyErrorMenssage(error),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true },
      });
    } finally {
      setLoadingRelatorio(false);
      window.onbeforeunload = null;
    }
  };

  const showModalAddProducer = () => {
    setShowModalProducer((prevState) => !prevState);
  };

  function runIfTrialOk(action) {
    const user = getUserFromStorage();

    if (isExpiredTrial(user)) {
      setOpenModalTesteGratis(true);
      return;
    }

    action();
  }

  function handleShowModalImportPlanilha() {
    setShowModalProducer(false);
    runIfTrialOk(() => setShowModalImportPlanilha(true));
  }

  function handleShowModalImportIA() {
    setShowModalProducer(false);
    runIfTrialOk(() => setShowModalImportIA(true));
  }

  const validateArchieve = async () => {
    const user = getUserFromStorage();

    if (isExpiredTrial(user)) {
      setOpenModalTesteGratis(true);
      return;
    }

    // Fecha o modal de importação antes de abrir o de validação/loading —
    // do contrário os dois ficam sobrepostos (mesmo z-index) e o de loading
    // acaba renderizado atrás, já que é declarado primeiro no JSX.
    setShowModalImportPlanilha(false);
    setShowModalImportIA(false);

    setLoadingValidate(true);
    setOpenValidate(true);

    const formData = new FormData();
    formData.append("file", file[0]);

    try {
      if (tipoImport === 1) {
        const response = await api.post("/produtores/importar", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        if (response.status === 201) {
          setFile([]);
          setNamesfiles([]);
          setTextfile("");
          setLoadingValidate(false);

          store.addNotification({
            title: "Sucesso!",
            message: `${response.data.message} Assim que válidado chegará uma notificação para o email: ${USER_EMAIL.username}`,
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 7000,
              onScreen: true,
            },
          });
        }

        setLoadingValidate(false);
        setShowModalImportPlanilha(false);
        setShowModalImportIA(false);
      } else if (tipoImport === 2) {
        const response = await api.post(
          "/importar/cadastro/fazendas",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );

        if (response.status === 201) {
          setFile([]);
          setNamesfiles([]);
          setTextfile("");
          setLoadingValidate(false);

          store.addNotification({
            title: "Sucesso!",
            message: `${response.data.message} Assim que válidado chegará uma notificação para o email: ${USER_EMAIL.username}`,
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 7000,
              onScreen: true,
            },
          });
        }

        setLoadingValidate(false);
        setShowModalImportPlanilha(false);
        setShowModalImportIA(false);
      }
    } catch (e) {
      if (e.response.status === 422) {
        setErrosArquivo(e.response.data.data);
        setLoadingValidate(false);
      }
      if (e.response.status === 400) {
        setFile([]);
        setNamesfiles([]);
        setTextfile("");
        setLoadingValidate(false);

        store.addNotification({
          title: "Erro!",
          message: `${e.response.data.errors}`,
          type: "danger",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 4000,
            onScreen: true,
          },
        });
      } else {
        let i = document.getElementById("input-file");
        i.value = "";

        setFile([]);
        setNamesfiles([]);
        setTextfile("");
        setLoadingValidate(false);

        store.addNotification({
          title: "Erro!",
          message: `${e.response.data.errors}`,
          type: "danger",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 4000,
            onScreen: true,
          },
        });
      }
    }
  };

  const handleFileSelected = (fileObj) => {
    setFile([fileObj]);
    setNamesfiles([fileObj.name]);
  };

  const handleFileRejected = (motivo) => {
    store.addNotification({
      title: "Erro!",
      message: motivo,
      type: "danger",
      insert: "top",
      container: "top-right",
      animationIn: ["animated", "fadeIn"],
      animationOut: ["animated", "fadeOut"],
      dismiss: {
        duration: 4000,
        onScreen: true,
      },
    });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        tooltipRef.current &&
        !tooltipRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setShowModalProducer(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [width, setWidth] = useState(window.innerWidth);
  const [totalSlices, setTotalSlices] = useState(4);

  const isMobile = width <= 768;

  useEffect(() => {
    if (isMobile) {
      setTotalSlices(3);
    } else {
      setTotalSlices(4);
    }
  }, [isMobile]);

  // Troca automaticamente pra cards ao entrar em largura mobile (e de volta
  // pra tabela ao sair) - só dispara quando o breakpoint muda de verdade,
  // já que o efeito só reage a mudanças em `isMobile`.
  useEffect(() => {
    setLayoutView(isMobile ? "cards" : "table");
  }, [isMobile]);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const isTableView = layoutView === "table";
  const hasProdutores = Array.isArray(produtores) && produtores.length > 0;
  const isBusy =
    layoutLoading || (loading && (!hasProdutores || (isTableView && pageLoading)));
  const produtoresPage = produtores;
  // Tanto a tabela quanto os cards mostram uma linha/card por FAZENDA (não por
  // produtor) — um produtor com várias fazendas ocupa várias linhas. Por isso
  // o botão "Ver mais" precisa comparar contra o total de fazendas já
  // carregadas, não contra totalProdutores (que é a contagem de produtores
  // vinda da API e pode ser bem menor que o total de linhas exibidas).
  const totalFarmRows = produtores.reduce(
    (acc, produtor) =>
      acc + Math.max(produtor?.agro_farms?.length || 0, 1),
    0,
  );
  const expandedCards = (() => {
    if (!showAll) return [];

    const list = [];
    for (const produtor of produtoresPage) {
      if (list.length >= EXPANDED_LIMIT) break;

      if (
        Array.isArray(produtor?.agro_farms) &&
        produtor.agro_farms.length > 0
      ) {
        for (const farm of produtor.agro_farms) {
          if (list.length >= EXPANDED_LIMIT) break;
          list.push({ produtor, farm });
        }
      } else {
        list.push({ produtor, farm: null });
      }
    }
    return list;
  })();

  const expandedTableRows = (() => {
    if (!showAll) return [];

    const sorted = [...produtoresPage].sort(
      (a, b) => new Date(b.modified) - new Date(a.modified),
    );
    const rows = [];
    for (const produtor of sorted) {
      if (rows.length >= EXPANDED_LIMIT) break;

      if (
        Array.isArray(produtor?.agro_farms) &&
        produtor.agro_farms.length > 0
      ) {
        for (const farm of produtor.agro_farms) {
          if (rows.length >= EXPANDED_LIMIT) break;
          rows.push({ produtor, farm });
        }
      } else {
        rows.push({ produtor, farm: null });
      }
    }
    return rows;
  })();

  return (
    <S.Container>
      <S.Wrapper>
        <S.ContainerInputAndButton>
          <SwitchLayout
            isTableView={isTableView}
            onClick={() => changeLayoutView(isTableView ? "cards" : "table")}
            disabled={layoutLoading}
          />

          <S.ContainerInput>
            <Search
              placeholder="Nome do produtor, Fazenda, Cultura, etc..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onBlur={() => getProdutoresReset(order)}
              onKeyDown={onKeyDown}
              onClear={() => {
                setSearch("");
                getProdutoresReset(order);
              }}
            />
          </S.ContainerInput>

          <ButtonList
            id="order"
            width="200px"
            border="none"
            options={[
              {
                value: "modified",
                label: "Últimas atualizações",
                order: "DESC",
              },
              {
                value: "nome_produtor",
                label: "Nome do Produtor",
                order: "ASC",
              },
              { value: "nome_fazenda", label: "Fazenda", order: "ASC" },
            ]}
            onSelected={(e) => updateOrder(e)}
            value={order}
            widthOption="200px"
          />

          {width > 760 && (
            <ButtonV2
              width="112px"
              height="42px"
              value="RELATÓRIOS"
              outline={!loadingRelatorio}
              disabled={false}
              onClick={() => setShowRelatorios(true)}
              loading={loadingRelatorio}
              color="#21262f"
            />
          )}


          <S.ButtonAndTooltipWrapper ref={buttonRef}>
            <ButtonV2
              width="230px"
              height="42px"
              value={width > 760 ? "ADICIONAR PRODUTOR" : "Adicionar"}
              outline={false}
              disabled={!canAddProdutor}
              onClick={canAddProdutor ? showModalAddProducer : undefined}
              loading={false}
              tooltip={true}
              tooltipMsg=""
              imagePlus={true}
            />

            {showModalProducer && (
              <S.Tooltip ref={tooltipRef}>
                <S.TooltipOption type="button" onClick={redirectToProducerAdd}>
                  <svg width="18" height="18" viewBox="0 0 16 16" fill="none">
                    <circle cx="8" cy="5" r="2.5" stroke="currentColor" strokeWidth="1.5" />
                    <path d="M3 13.5c.7-2.3 2.7-3.5 5-3.5s4.3 1.2 5 3.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                  </svg>
                  <S.TooltipOptionText>
                    <b>Cadastrar manualmente</b>
                    <span>Preencha o formulário completo</span>
                  </S.TooltipOptionText>
                </S.TooltipOption>

                <S.TooltipOption type="button" onClick={handleShowModalImportPlanilha}>
                  <svg width="18" height="18" viewBox="0 0 16 16" fill="none">
                    <rect x="2" y="2.5" width="12" height="11" rx="1.5" stroke="currentColor" strokeWidth="1.4" />
                    <path d="M2 6h12M6 2.5v11" stroke="currentColor" strokeWidth="1.4" />
                  </svg>
                  <S.TooltipOptionText>
                    <b>Importar com planilha</b>
                    <span>Envie a planilha seguindo nosso modelo</span>
                  </S.TooltipOptionText>
                </S.TooltipOption>

                <S.TooltipOption type="button" onClick={handleShowModalImportIA}>
                  <svg width="18" height="18" viewBox="0 0 16 16" fill="none">
                    <path d="M8 1.5l1.35 3.65L13 6.5l-3.65 1.35L8 11.5l-1.35-3.65L3 6.5l3.65-1.35L8 1.5z" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round" />
                    <path d="M13 11l.5 1.4L15 13l-1.5.6L13 15l-.5-1.4L11 13l1.5-.6L13 11z" stroke="currentColor" strokeWidth="1.1" strokeLinejoin="round" />
                  </svg>
                  <S.TooltipOptionText>
                    <b>Importar com IA</b>
                    <span>Envie qualquer planilha, a IA organiza pra você</span>
                  </S.TooltipOptionText>
                </S.TooltipOption>
              </S.Tooltip>
            )}
          </S.ButtonAndTooltipWrapper>
        </S.ContainerInputAndButton>

        <S.LayoutArea>
          {isBusy ? (
            <S.ContainerLoading>
              <S.Loading outline={true} style={{ width: 80, height: 80 }} />
            </S.ContainerLoading>
          ) : isTableView ? (
            hasProdutores ? (
              (() => {
                const sorted = [...produtoresPage].sort(
                  (a, b) => new Date(b.modified) - new Date(a.modified),
                );

                const rows = [];
                if (showAll) {
                  rows.push(...expandedTableRows);
                } else {
                  for (const produtor of sorted) {
                    if (rows.length >= totalSlices) break;

                    if (
                      Array.isArray(produtor?.agro_farms) &&
                      produtor.agro_farms.length > 0
                    ) {
                      for (const farm of produtor.agro_farms) {
                        if (rows.length >= totalSlices) break;
                        rows.push({ produtor, farm });
                      }
                    } else {
                      rows.push({ produtor, farm: null });
                    }
                  }
                }

                return (
                  <>
                    <TableWithLabelBlackV2
                      getRowStyle={(row) =>
                        row?.produtor?.status !== 1
                          ? { backgroundColor: theme.colors.disabled.Fundo_Desabilitado }
                          : undefined
                      }
                      actionsColumn={{
                        enabled: true,
                        position: "first",
                        label: "AÇÕES",
                        width: "100%",
                        minWidth: "80px",
                        maxWidth: "112px",
                        justifyContent: "flex-start",
                        buttons: [
                          {
                            key: "edit",
                            icon: IconPenEdit,
                            iconAlt: "Ícone de edição",
                            tooltip: "Editar produtor",
                            ariaLabel: "Editar produtor",
                            href: (row) => {
                              const produtorId = row?.produtor?.id;
                              if (produtorId) return `/produtores/${produtorId}`;
                              return null;
                            }
                          },
                          {
                            key: "view",
                            icon: IconBarChartGray,
                            iconAlt: "Ícone de gráfico",
                            tooltip: "Ver detalhes",
                            ariaLabel: "Ver detalhes",
                            isVisible: (row) => !!row?.farm?.id,
                            href: (row) => {
                              const produtorId = row?.produtor?.id;
                              const farmId = row?.farm?.id;
                              if (farmId && produtorId) return `/fazendas/${farmId}/${produtorId}`;
                              return null;
                            }
                          }
                        ]
                      }}
                      columns={[
                        {
                          key: "produtor",
                          label: "Produtor",
                          minWidth: "240px",
                          width: "320px",
                          maxWidthContent: "320px",
                          enableHorizontalScroll: true,
                          render: (row) => (
                            <BodyM
                              color={row?.produtor?.status !== 1 ? "#AAAAAA" : theme.colors.gray.Cinza_2}
                              fontWeight={800}
                            >
                              {row?.produtor?.nome ?? "-"}
                            </BodyM>
                          ),
                        },
                        {
                          key: "status",
                          label: "Status",
                          minWidth: "130px",
                          width: "140px",
                          render: (row) => (
                            <TextOrStatus
                              maxWidth="auto"
                              type="status"
                              status={row?.produtor?.status === 1 ? 2 : 3}
                              textSuccess="Ativo"
                              textError="Inativo"
                            />
                          ),
                        },
                        {
                          key: "fazenda",
                          label: "Fazenda",
                          minWidth: "240px",
                          width: "260px",
                          maxWidthContent: "260px",
                          enableHorizontalScroll: true,
                          render: (row) => (
                            <TaglineP
                              color={row?.produtor?.status !== 1 ? "#AAAAAA" : theme.colors.gray.Cinza_2}
                              fontWeight={600}
                            >
                              {row?.farm?.nome ?? "Fazenda não vinculada"}
                            </TaglineP>
                          ),
                        },
                        {
                          key: "cidade",
                          label: "Cidade",
                          minWidth: "160px",
                          width: "180px",
                          maxWidthContent: "180px",
                          enableHorizontalScroll: true,
                          render: (row) => {
                            const cidade = row?.farm?.cidade;
                            const estado = row?.farm?.estado;
                            const label = cidade
                              ? estado ? `${cidade} - ${estado}` : cidade
                              : "-";
                            return (
                              <TaglineP color={row?.produtor?.status !== 1 ? "#AAAAAA" : theme.colors.gray.Cinza_2} fontWeight={600}>
                                {label}
                              </TaglineP>
                            );
                          },
                        },
                        {
                          key: "uf",
                          label: "UF",
                          minWidth: "70px",
                          width: "80px",
                          maxWidthContent: "80px",
                          render: (row) => (
                            row?.farm?.estado ? (
                              <Badge colorBg={theme.colors.gray.Cinza_2} colorText={theme.colors.white.Branco}>
                                {row.farm.estado}
                              </Badge>
                            ) : (
                              <TaglineP color={theme.colors.gray.Cinza_2} fontWeight={600}>-</TaglineP>
                            )
                          ),
                        },
                        {
                          key: "cultura",
                          label: "Cultura",
                          minWidth: "270px",
                          width: "290px",
                          maxWidthContent: "290px",
                          enableHorizontalScroll: true,
                          render: (row) => (
                            <>
                              {Array.isArray(row?.farm?.agro_farms_cultures) &&
                                row.farm.agro_farms_cultures.length > 0 ? (
                                <S.ContainerCulture
                                  style={{
                                    flexDirection: "column",
                                    alignItems: "flex-start",
                                    overflowX: "visible",
                                  }}
                                >
                                  {row.farm.agro_farms_cultures
                                    .map((c) => c?.agro_cultures?.nome_comum)
                                    .filter(Boolean)
                                    .map((nome, idx) => (
                                      <S.CardCulture
                                        key={`${row?.produtor?.id ?? "p"}-${row?.farm?.id ?? "f"}-c-${idx}`}
                                        style={{ cursor: "pointer" }}
                                        onClick={(e) => { e.stopPropagation(); openCulturaUrl(nome); }}
                                      >
                                        <TaglineP
                                          color={theme.colors.white.Branco}
                                          fontWeight={800}
                                        >
                                          {nome}
                                        </TaglineP>
                                      </S.CardCulture>
                                    ))}
                                </S.ContainerCulture>
                              ) : (
                                <TaglineP
                                  color={row?.produtor?.status !== 1 ? "#AAAAAA" : theme.colors.gray.Cinza_2}
                                  fontWeight={600}
                                >
                                  -
                                </TaglineP>
                              )}
                            </>
                          ),
                        },
                        {
                          key: "updated",
                          label: "Última atualização",
                          minWidth: "195px",
                          width: "100%",
                          maxWidthContent: "100%",
                          render: (row) => (
                            <TaglineP
                              color={row?.produtor?.status !== 1 ? "#AAAAAA" : theme.colors.gray.Cinza_2}
                              fontWeight={600}
                            >
                              {row?.produtor?.modified
                                ? `Atualizado ${formatarData(row.produtor.modified)}`
                                : "-"}
                            </TaglineP>
                          ),
                        },
                      ]}
                      data={rows}
                      showAll={true}
                      itemsPerPage={rows.length}
                      serverSide={true}
                      getRowId={(row, idx) =>
                        row?.farm?.id
                          ? `${row?.produtor?.id}_${row.farm.id}`
                          : `${row?.produtor?.id}_no_farm_${idx}`
                      }
                    />

                  </>
                );
              })()
            ) : null
          ) : hasProdutores ? (
            <S.ContainerLocalization
              ref={containerRef}
              className="animate__animated"
            >
              {showAll ? (
                <>
                  {expandedCards.map(({ produtor, farm }, idx) => (
                    <S.Cardlocalization
                      $inativo={produtor.status !== 1}
                      key={
                        farm
                          ? `${produtor.id}_${farm.id}`
                          : `${produtor.id}_no_farm_${idx}`
                      }
                      onClick={() => {
                        if (farm?.id) {
                          window.location.href = `/fazendas/${farm.id}/${produtor.id}`;
                        } else {
                          window.location.href = `/produtores/${produtor.id}`;
                        }
                      }}
                    >
                      <S.ProductorAndLocal>
                        <S.ProductorName>
                          <Auxiliar color={theme.colors.gray.Cinza_2}>
                            {produtor.nome}
                          </Auxiliar>

                          <Auxiliar color={theme.colors.gray.Cinza_6}>
                            CPF/CNPJ: {produtor.cpf_cnpj}
                          </Auxiliar>

                          <BodyM
                            color={theme.colors.gray.Cinza_2}
                            fontWeight={700}
                          >
                            {farm ? farm.nome : "Fazenda não vinculada"}
                          </BodyM>

                          <Auxiliar color={theme.colors.gray.Cinza_2}>
                            {farm?.cidade && farm?.estado ? (<>{farm?.cidade} - {farm?.estado}</>) : null}
                          </Auxiliar>
                        </S.ProductorName>

                        {produtor.notification && (
                          <S.ContainerImage>
                            <img src={IconBell} alt="Ícone de notificação" />
                          </S.ContainerImage>
                        )}
                      </S.ProductorAndLocal>
                      <TextOrStatus
                        maxWidth="auto"
                        type="status"
                        status={produtor.status === 1 ? 2 : 3}
                        textSuccess="Ativo"
                        textError="Inativo"
                      />
                      <S.ContainerCulture>
                        {farm?.agro_farms_cultures?.map((c) => (
                          <S.CardCulture
                            key={c.agro_cultures.id}
                            style={{ cursor: "pointer" }}
                            onClick={(e) => { e.stopPropagation(); openCulturaUrl(c.agro_cultures.nome_comum); }}
                          >
                            <TaglineP
                              color={theme.colors.white.Branco}
                              fontWeight={800}
                            >
                              {c.agro_cultures.nome_comum}
                            </TaglineP>
                          </S.CardCulture>
                        ))}
                      </S.ContainerCulture>

                      <TaglineP
                        color={theme.colors.gray.Cinza_2}
                        fontWeight={600}
                      >
                        Atualizado {formatarData(produtor.modified)}
                      </TaglineP>
                    </S.Cardlocalization>
                  ))}

                  {loading && (
                    <>
                      <S.Cardlocalization key={`loading_1`} loading={loading} />
                      <S.Cardlocalization key={`loading_2`} loading={loading} />
                      <S.Cardlocalization key={`loading_3`} loading={loading} />
                      <S.Cardlocalization key={`loading_4`} loading={loading} />
                    </>
                  )}
                </>
              ) : (
                (() => {
                  const sorted = [...produtores].sort(
                    (a, b) => new Date(b.modified) - new Date(a.modified),
                  );

                  const farmsToShow = [];
                  for (const produtor of sorted) {
                    if (farmsToShow.length >= totalSlices) break;

                    if (produtor.agro_farms.length > 0) {
                      for (const farm of produtor.agro_farms) {
                        if (farmsToShow.length >= totalSlices) break;
                        farmsToShow.push({ produtor, farm });
                      }
                    } else {
                      if (farmsToShow.length < totalSlices) {
                        farmsToShow.push({ produtor, farm: null });
                      }
                    }
                  }

                  return farmsToShow.map(({ produtor, farm }, index) => (
                    <S.Cardlocalization
                      $inativo={produtor.status !== 1}
                      key={
                        farm
                          ? `${produtor.id}_${farm.id}`
                          : `${produtor.id}_no_farm`
                      }
                      onClick={() => {
                        if (farm) {
                          window.location.href = `/fazendas/${farm.id}/${produtor.id}`;
                        } else {
                          window.location.href = `/produtores/${produtor.id}`;
                        }
                      }}
                    >
                      <S.ProductorAndLocal>
                        <S.ProductorName>
                          <Auxiliar color={theme.colors.gray.Cinza_2}>
                            {produtor.nome}
                          </Auxiliar>

                          <Auxiliar color={theme.colors.gray.Cinza_6}>
                            CPF/CNPJ: {produtor.cpf_cnpj}
                          </Auxiliar>

                          <BodyM
                            color={theme.colors.gray.Cinza_2}
                            fontWeight={700}
                          >
                            {farm ? farm.nome : "Fazenda não vinculada"}
                          </BodyM>

                          <Auxiliar color={theme.colors.gray.Cinza_2}>
                            {farm?.cidade && farm?.estado ? (<>{farm?.cidade} - {farm?.estado}</>) : null}
                          </Auxiliar>
                        </S.ProductorName>

                        {produtor.notification && (
                          <S.ContainerImage>
                            <img src={IconBell} alt="Ícone de notificação" />
                          </S.ContainerImage>
                        )}
                      </S.ProductorAndLocal>

                      <TextOrStatus
                        maxWidth="auto"
                        type="status"
                        status={produtor.status === 1 ? 2 : 3}
                        textSuccess="Ativo"
                        textError="Inativo"
                      />

                      <S.ContainerCulture>
                        {farm?.agro_farms_cultures?.map((c) => (
                          <S.CardCulture
                            key={c.agro_cultures.id}
                            style={{ cursor: "pointer" }}
                            onClick={(e) => { e.stopPropagation(); openCulturaUrl(c.agro_cultures.nome_comum); }}
                          >
                            <TaglineP
                              color={theme.colors.white.Branco}
                              fontWeight={800}
                            >
                              {c.agro_cultures.nome_comum}
                            </TaglineP>
                          </S.CardCulture>
                        ))}
                      </S.ContainerCulture>

                      {/* Já está correto aqui */}
                      <TaglineP
                        color={theme.colors.gray.Cinza_2}
                        fontWeight={600}
                      >
                        Atualizado {formatarData(produtor.modified)}
                      </TaglineP>
                    </S.Cardlocalization>
                  ));
                })()
              )}
            </S.ContainerLocalization>
          ) : null}

          {!isBusy && !hasProdutores && (
            <S.ContainerItemNotFound>
              <img src={ItemNotFound} alt="Ícone de pesquisa" />

              <H6 color={theme.colors.gray.Cinza_2}>
                Nenhuma fazenda encontrada!
              </H6>
            </S.ContainerItemNotFound>
          )}

          {!isBusy &&
            hasProdutores &&
            (showAll && totalProdutores > EXPANDED_LIMIT ? (
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <PaginatorV2
                  perPage={EXPANDED_LIMIT}
                  total={totalProdutores}
                  totalItens={
                    isTableView
                      ? expandedTableRows.length
                      : expandedCards.length
                  }
                  currentPage={currentPage}
                  onChange={(l, o) =>
                    updateLimitOffset(l, o, order, {
                      showPageLoading: isTableView,
                    })
                  }
                />
              </div>
            ) : null)}

          {!isBusy && hasProdutores && (showAll || totalFarmRows > totalSlices) && (
            <S.ButtonShowAll onClick={toggleShowAll}>
              <TaglineP color={theme.colors.gray.Cinza_2} fontWeight={800}>
                {showAll ? "Ver menos" : "Ver mais"}
              </TaglineP>

              <img
                src={ArrowDown}
                alt="Ícone de flecha direcionada para baixo"
                style={{
                  transform: showAll ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.3s ease",
                }}
              />
            </S.ButtonShowAll>
          )}
        </S.LayoutArea>

        <Modal
          show={openValidate}
          onHide={(e) => {
            setOpenValidate(false);
            setErrosArquivo([]);
          }}
          width="70%"
        >
          <S.Row>
            {errosArquivo.length > 0 ? (
              <S.Title>Encontramos alguns problemas...</S.Title>
            ) : (
              <S.Title>Validando arquivo...</S.Title>
            )}
          </S.Row>
          {errosArquivo.length > 0 ? (
            <>
              <SimpleTable>
                <thead>
                  <tr>
                    <th>Linha</th>
                    <th
                      style={{
                        textAlign: "left",
                      }}
                    >
                      Erros
                    </th>
                  </tr>
                </thead>
                <SimpleTBodyContainer>
                  {errosArquivo.map((erros) => (
                    <tr>
                      <td
                        style={{
                          textAlign: "center",
                        }}
                      >
                        {erros.linha}
                      </td>
                      <td>{erros.erros}</td>
                    </tr>
                  ))}
                </SimpleTBodyContainer>
              </SimpleTable>

              <S.Row>
                <S.Text>
                  <b>
                    Você precisa corrigir os erros acima para continuar com a
                    importação!
                  </b>
                </S.Text>
              </S.Row>

              <S.Row>
                <ButtonV2
                  width="25%"
                  height="50px"
                  value="ENTENDI"
                  outline={false}
                  disabled={false}
                  onClick={() => closeValidate()}
                  loading={false}
                />
              </S.Row>
            </>
          ) : loadingValidate ? (
            <S.Loading outline={true} />
          ) : null}
        </Modal>

        <Modal
          show={showModalImportPlanilha}
          onHide={() => setShowModalImportPlanilha(false)}
          paddingModalCard="24px"
          width="720px"
          removeHeader
          marginBottom="0"
        >
          <S.ImportDataHeader>
            <S.ImportDataModalTitle>Importar dados</S.ImportDataModalTitle>
            <S.ImportDataCloseButton
              type="button"
              aria-label="Fechar"
              onClick={() => setShowModalImportPlanilha(false)}
            >
              <img src={IconClose} alt="" />
            </S.ImportDataCloseButton>
          </S.ImportDataHeader>

          <S.ImportDataTabs>
            <TabTitle
              active={tipoImport === 1}
              onClick={() => setTipoImport(1)}
              icon={IconProdutoresTab}
              title="Produtores"
              description="Importe seus clientes"
            />

            <S.ImportDataTabsDivider />

            <TabTitle
              active={tipoImport === 2}
              onClick={() => setTipoImport(2)}
              icon={IconLocaisAplicacaoTab}
              title="Locais de aplicação"
              description="Importe as propriedades dos produtores"
            />
          </S.ImportDataTabs>

          <S.ImportDataSectionLabel>
            {tipoImport === 1 ? 'Como importar produtores' : 'Como importar locais de aplicação'}
          </S.ImportDataSectionLabel>

          <S.ImportDataSteps>
            {tipoImport === 2 && (
              <S.ImportDataStep>
                <S.ImportDataStepNumber>1</S.ImportDataStepNumber>
                <S.ImportDataStepText>
                  Certifique-se de já ter feito o cadastro ou a importação dos seus produtores.
                </S.ImportDataStepText>
              </S.ImportDataStep>
            )}

            <S.ImportDataStep>
              <S.ImportDataStepNumber>{tipoImport === 2 ? 2 : 1}</S.ImportDataStepNumber>
              <S.ImportDataStepText>
                <S.Download onClick={() => tipoImport === 1 ? downloadProducersModel() : downloadFarmsModel()}>
                  Baixe o modelo de planilha
                </S.Download>
              </S.ImportDataStepText>
            </S.ImportDataStep>

            <S.ImportDataAttentionBox>
              <b>Atenção:</b> preencha todas as colunas marcadas como obrigatórias e não remova a primeira linha da planilha.
            </S.ImportDataAttentionBox>

            <S.ImportDataStep>
              <S.ImportDataStepNumber>{tipoImport === 2 ? 3 : 2}</S.ImportDataStepNumber>
              <S.ImportDataStepText>
                Selecione o arquivo preenchido e clique em Importar.
              </S.ImportDataStepText>
            </S.ImportDataStep>
          </S.ImportDataSteps>

          <PlanilhaDropzone
            descricao={tipoImport === 1
              ? 'Envie a planilha de produtores preenchida conforme o modelo baixado acima.'
              : 'Envie a planilha de locais de aplicação preenchida conforme o modelo baixado acima.'}
            arquivo={namesfiles.length > 0 ? {
              nome: namesfiles[0],
              tamanho: file[0] ? formatFileSize(file[0].size) : '',
              extensao: namesfiles[0].split('.').pop() || '',
            } : null}
            onSelect={handleFileSelected}
            onRemove={deleteFile}
            onReject={handleFileRejected}
          />

          <S.ImportFooter>
            <S.ImportFooterNote>
              Os registros duplicados são ignorados automaticamente.
            </S.ImportFooterNote>
            <S.ImportFooterActions>
              <ButtonV2
                width="120px"
                height="44px"
                value="CANCELAR"
                outline={true}
                color={theme.colors.gray.Cinza_2}
                disabled={false}
                onClick={() => setShowModalImportPlanilha(false)}
              />
              <ButtonV2
                width="150px"
                height="44px"
                value="IMPORTAR"
                outline={false}
                disabled={namesfiles.length === 0}
                onClick={() => validateArchieve()}
                loading={loadingImport}
              />
            </S.ImportFooterActions>
          </S.ImportFooter>
        </Modal>

        <Modal
          show={showModalImportIA}
          onHide={() => setShowModalImportIA(false)}
          paddingModalCard="24px"
          width="620px"
          removeHeader
        >
          <S.ImportDataHeader>
            <S.ImportDataModalTitle>Importar com IA</S.ImportDataModalTitle>
            <S.ImportDataCloseButton
              type="button"
              aria-label="Fechar"
              onClick={() => setShowModalImportIA(false)}
            >
              <img src={IconClose} alt="" />
            </S.ImportDataCloseButton>
          </S.ImportDataHeader>

          <S.ImportDataTabs>
            <TabTitle
              active={tipoImport === 1}
              onClick={() => setTipoImport(1)}
              icon={IconProdutoresTab}
              title="Produtores"
              description="Importe seus clientes"
            />

            <S.ImportDataTabsDivider />

            <TabTitle
              active={tipoImport === 2}
              onClick={() => setTipoImport(2)}
              icon={IconLocaisAplicacaoTab}
              title="Locais de aplicação"
              description="Importe as propriedades dos produtores"
            />
          </S.ImportDataTabs>

          <PlanilhaDropzone
            descricao={tipoImport === 1
              ? 'Envie a planilha de clientes de qualquer sistema. Nossa IA identifica as colunas e preenche os campos automaticamente.'
              : 'Envie a planilha de propriedades de qualquer sistema. Nossa IA identifica as colunas, vincula cada local ao produtor e preenche os campos automaticamente.'}
            arquivo={namesfiles.length > 0 ? {
              nome: namesfiles[0],
              tamanho: file[0] ? formatFileSize(file[0].size) : '',
              extensao: namesfiles[0].split('.').pop() || '',
            } : null}
            onSelect={handleFileSelected}
            onRemove={deleteFile}
            onReject={handleFileRejected}
          />

          <S.ImportChecklistLabel>O que acontece depois do envio</S.ImportChecklistLabel>
          <S.ImportStepsList>
            <S.ImportStepItem>
              <svg width="15" height="15" viewBox="0 0 16 16" fill="none">
                <path d="M3 8.5L6.5 12 13 4.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              <span>
                Nossa IA lê a sua planilha, reconhece as colunas e cadastra <b>todos os registros completos</b>.
              </span>
            </S.ImportStepItem>

            <S.ImportStepItem>
              <svg width="15" height="15" viewBox="0 0 16 16" fill="none">
                <path d="M8 2.5v7m0 0L5.5 7M8 9.5L10.5 7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M3 11v1.5A1 1 0 004 13.5h8a1 1 0 001-1V11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
              </svg>
              <span>
                Se faltar algum dado obrigatório, você recebe uma <b>planilha de devolução</b> apenas com os registros incompletos.
              </span>
            </S.ImportStepItem>

            <S.ImportStepItem>
              <svg width="15" height="15" viewBox="0 0 16 16" fill="none">
                <path d="M8 2.5a5.5 5.5 0 105.5 5.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                <path d="M13.5 3v3h-3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              <span>
                Complete os campos que faltam nessa planilha e <b>faça um novo envio</b> para finalizar a importação.
              </span>
            </S.ImportStepItem>
          </S.ImportStepsList>

          <S.ImportFooter>
            <S.ImportFooterNote>
              Nossa IA cadastra os registros completos e devolve os incompletos em uma planilha.
            </S.ImportFooterNote>
            <S.ImportFooterActions>
              <ButtonV2
                width="120px"
                height="44px"
                value="CANCELAR"
                outline={true}
                color={theme.colors.gray.Cinza_2}
                disabled={false}
                onClick={() => setShowModalImportIA(false)}
              />
              <ButtonV2
                width="170px"
                height="44px"
                value="IMPORTAR COM IA"
                outline={false}
                disabled={namesfiles.length === 0}
                onClick={() => validateArchieve()}
                loading={loadingImport}
              />
            </S.ImportFooterActions>
          </S.ImportFooter>
        </Modal>

        {openModalTesteGratis ? (
          <ModalGeneric
            show={openModalTesteGratis}
            onHide={() => setOpenModalTesteGratis(false)}
          >
            <ModalContainer>
              <img
                src={ModalImageRecursoClientes}
                alt="Recurso exclusivo para clientes"
              />

              <H5 color={theme.colors.gray.Cinza_5}>Recurso exclusivo para clientes</H5>

              <BodyG color={theme.colors.gray.Cinza_5}>
                Para não comprometer o controle de suas receitas agronômicas durante o
                período de teste esta função é bloqueada.
              </BodyG>

              <Auxiliar color={theme.colors.gray.Cinza_4}>
                Assine o AgroReceita para desbloquear esta função!
              </Auxiliar>

              <div
                className="button-finish"
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  marginTop: "20px",
                }}
              >
                <ButtonV2
                  width="90%"
                  height="60px"
                  value="Ver Planos"
                  outline={false}
                  disabled={false}
                  onClick={() => {
                    setOpenModalTesteGratis(false);
                    window.location = "/planos";
                  }}
                  loading={false}
                />
              </div>
            </ModalContainer>
          </ModalGeneric>
        ) : null}

        {openModalBlocked ? (
          <ModalGeneric
            show={openModalBlocked}
            onHide={() => setOpenModalBlocked(false)}
          >
            <ModalContainer>
              <img
                src={ModalImageRecursoClientes}
                alt="Função bloqueada no plano"
              />

              <H5 color={theme.colors.gray.Cinza_5}>
                Essa função não está liberada para o seu plano
              </H5>

              <BodyG color={theme.colors.gray.Cinza_5}>
                Faça um upgrade para desbloquear esse recurso
              </BodyG>

              <div
                className="button-finish"
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  marginTop: "20px",
                }}
              >
                <ButtonV2
                  width="90%"
                  height="60px"
                  value="Ver Planos"
                  outline={false}
                  disabled={false}
                  onClick={() => {
                    setOpenModalBlocked(false);
                    window.location = "/planos";
                  }}
                  loading={false}
                />
              </div>
            </ModalContainer>
          </ModalGeneric>
        ) : null}

        <ModalGeneric
          show={showRelatorios}
          onHide={() => setShowRelatorios(false)}
          size="lg"
        >
          <h4 style={{ textAlign: "center" }}>
            Escolha qual relatório deseja exportar
          </h4>

          <div
            className="button-finish"
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-evenly",
              alignItems: "center",
              marginTop: "40px",
              paddingTop: "32px",
            }}
          >
            <ButtonV2
              width="30%"
              height="50px"
              value="PRODUTORES"
              outline={!loading}
              disabled={false}
              onClick={() => getXlms()}
              loading={loading}
            />

            <ButtonV2
              width="30%"
              height="50px"
              value="LOCAIS DE APLICAÇÂO"
              outline={!loading}
              disabled={false}
              onClick={() => getXlmsFarms()}
              loading={loading}
            />
          </div>
        </ModalGeneric>
      </S.Wrapper>
    </S.Container>
  );
};

export default ListaProdutores
